import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentQuotationTask } from '@/providers/QuotationTaskProvider';
import { useCreateQuotationTaskDocument } from '@/hooks/api/1550_create_quotation_task_document';
import { useQuotationTaskDocumentsInvalidate } from '@/hooks/api/1540_quotation_task_documents';
import { SubmitHandler, useForm } from 'react-hook-form';
import React, { useEffect } from 'react';
import { toastApiError } from '@/lib/toast';
import { FormGroup } from '@/components/element/Form/FormGroup';
import { isValidURL } from '@/utils';
import { useParams } from 'react-router-dom';
import { useQuotationTaskInvalidate } from '@/hooks/api/1480_quotation_task';

type FormInputs = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  name: string;
  url: string;
};

export const UrlForm = () => {
  const { setShowLoading } = useLoading();
  const { _w_, _t_ } = useCurrentTeamMember();
  const { sales_order_id } = useParams();
  const { quotationTask: task } = useCurrentQuotationTask();
  const { mutate, data, isPending, error } = useCreateQuotationTaskDocument();
  const { invalidate } = useQuotationTaskDocumentsInvalidate({
    identifier: _w_!.identifier,
    team_id: _t_!.id,
    sales_order_id: Number(sales_order_id),
    task_id: task!.id,
  });
  const { invalidate: invalidateTask } = useQuotationTaskInvalidate({
    identifier: _w_!.identifier,
    team_id: _t_!.id,
    sales_order_id: Number(sales_order_id!),
    id: task!.id,
  });

  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInputs>({
    mode: 'onSubmit',
    criteriaMode: 'all',
    defaultValues: {
      identifier: _w_!.identifier,
      team_id: _t_!.id,
      sales_order_id: Number(sales_order_id),
      task_id: task!.id,
    },
  });

  useEffect(() => setShowLoading(isPending), [isPending]);
  useEffect(() => toastApiError(error), [error]);

  useEffect(() => {
    if (data) {
      setValue('name', '');
      setValue('url', '');
      invalidate();
      invalidateTask();
    }
  }, [data]);

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    setShowLoading(true);
    mutate(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="d-flex">
        <FormGroup label="URLを追加" required={true} classes={'me-2 flex-1'}>
          <input
            type="text"
            maxLength={50}
            className={`form-control ${errors.name && 'is-invalid'}`}
            placeholder={'名称'}
            {...register('name', { required: '入力して下さい。' })}
          />
        </FormGroup>

        <FormGroup label="　" classes={'me-2 flex-1'}>
          <input
            type="text"
            maxLength={200}
            className={`form-control ${errors.url && 'is-invalid'}`}
            placeholder={'URL'}
            {...register('url', {
              required: '入力して下さい。',
              validate: (d) => {
                if (!isValidURL(d)) return '無効なURLです。';
              },
            })}
          />
        </FormGroup>

        <div className="form-group flex-shrink-0">
          <label>&nbsp;</label>
          <button className="btn w-100 btn-icon bg-gradient-dark">
            <i className="fa fa-plus"></i>追加
          </button>
        </div>
      </div>
    </form>
  );
};
